import { render, staticRenderFns } from "./base-column-multiple-items.vue?vue&type=template&id=16cb7112&scoped=true&"
import script from "./base-column-multiple-items.vue?vue&type=script&lang=js&"
export * from "./base-column-multiple-items.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16cb7112",
  null
  
)

export default component.exports